import React from "react";
import { useNavigate } from "react-router-dom";
import RIcon from "../reservas/components/ReservasIcons";
import { BEAUTY_FALLBACK_IMAGE, resolveUrl } from "../reservas/components/ReservaShared";
import SalonContent from "./components/SalonContent";
import { SucursalBanner } from "../reservas/components/Sucursales";
import { backTarget } from "../reservas/components/sucursalesModel";
import { ONLINE_BOOKING_DISABLED_MESSAGE, isOnlineBookingDisabled } from "../reservas/onlineBooking";
import { formatMoney, minServicePrice, salonAddressLine, todayOpenStatus } from "./beautyBooking";
import "../reservas/reservas.css";
import "../reservas/reservas-mobile.css";
import "./beauty.css";

/** Mobile salon landing. Same structure as the Canchas club landing. */
const SalonDetailMobile = ({
  salon,
  services,
  professionals,
  onStartBooking,
  topSlot = null,
  sucursales = [],
  casaCentral = null,
  heroSalon = null,
  sedes = null,
  sedeStatus = null,
}) => {
  // On a casa central the hero stays the casa's while `salon` is the chosen sede.
  const hero = heroSalon || salon;
  const navigate = useNavigate();
  const img = resolveUrl(hero.image || hero.mobileimage) || BEAUTY_FALLBACK_IMAGE;
  const minPrice = minServicePrice(services);
  const address = salonAddressLine(hero);
  const eyebrow = (hero.serviceCategories || []).filter(Boolean).join(" · ");
  const openStatus = todayOpenStatus(hero.openingHours);
  const hasServices = services.length > 0 && !sedeStatus;
  // Salons are bookable unless explicitly turned off (clubs are the opposite: opt-in).
  const bookingDisabled = isOnlineBookingDisabled(salon);
  const goBack = () => navigate(backTarget("beauty", casaCentral).path);

  return (
    <div className="reservas-root rmob-root beauty-mobile">
      <SucursalBanner kind="beauty" casaCentral={casaCentral} />
      <div className="rmob-landing-hero">
        <img src={img} alt={hero.name} onError={(e) => { e.currentTarget.src = BEAUTY_FALLBACK_IMAGE; }} />
        <div className="rmob-hero-scrim" />
        <button type="button" className="rmob-back rmob-back-hero" onClick={goBack} aria-label="Volver">
          <RIcon name="chevL" width={20} height={20} />
        </button>
        {hero.reservationMode === "deposit" && (
          <span className="bd-pill">
            <RIcon name="shield" width={15} height={15} /> Con seña
          </span>
        )}
        <div className="rmob-hero-info">
          <h1 className="rmob-hero-name">{hero.name}</h1>
          <div className="rmob-hero-meta">
            {address && <span><RIcon name="pin" width={14} height={14} /> {address}</span>}
            {eyebrow && <span>{eyebrow}</span>}
            {openStatus && (
              <span data-testid="beauty-open-status"><RIcon name="clock" width={14} height={14} /> {openStatus.text}</span>
            )}
            {hasServices && minPrice !== null && <span>Desde {formatMoney(minPrice)}</span>}
          </div>
        </div>
      </div>

      <div className="rmob-landing-body">
        {topSlot}
        <SalonContent
          salon={salon}
          services={services}
          professionals={professionals}
          sucursales={sucursales}
          sedes={sedes}
          sedeStatus={sedeStatus}
          onBack={goBack}
        />
        <div className={hasServices ? "beauty-cta-spacer" : "beauty-cta-spacer is-short"} />
      </div>

      {hasServices && (
        <div className="rmob-cta-bar">
          {bookingDisabled && (
            <div className="rs-note" role="note" style={{ margin: "0 0 10px", color: "var(--zoco-gray-2)" }}>
              <RIcon name="info" width={15} height={15} />
              {ONLINE_BOOKING_DISABLED_MESSAGE}
            </div>
          )}
          <div className="rmob-cta-actions">
            {minPrice !== null && (
              <div className="beauty-cta-price">
                <span className="beauty-cta-label">Desde</span>
                <span className="beauty-cta-amount">{formatMoney(minPrice)}</span>
              </div>
            )}
            <button
              type="button"
              className="r-btn-primary rmob-cta-btn"
              onClick={() => onStartBooking?.()}
              disabled={bookingDisabled}
              aria-disabled={bookingDisabled}
            >
              Reservar turno <RIcon name="arrowR" width={18} height={18} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SalonDetailMobile;
